import firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"
import "firebase/storage"

const firebaseConfig = {
  apiKey: "AIzaSyBZpej0jfnqCZj4UXaHOVI9HLEpVII_4Q8",
  authDomain: "daysocialpostsplanner.firebaseapp.com",
  databaseURL: "https://daysocialpostsplanner.firebaseio.com",
  projectId: "daysocialpostsplanner",
  storageBucket: "daysocialpostsplanner.appspot.com",
  messagingSenderId: "181750157760",
  appId: "1:181750157760:web:edfb8811e88b75231d3825"
}
firebase.initializeApp(firebaseConfig)

const auth = firebase.auth()
const fireStore = firebase.firestore()
const fireStorage = firebase.storage()
const storageRef = fireStorage.ref()
const firebaseTimestamp = firebase.firestore.FieldValue.serverTimestamp

export { auth, fireStore, fireStorage, storageRef, firebaseTimestamp }
export default firebase